import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import CardProfile from "../../../../upload/CardProfile";
import MaskInput from "../../../../input/MaskInput";
import Input from "../../../../input/Input";
import CalendarInput from "../../../../input/CalendarInput";
import NumberInput from "../../../../input/NumberInput";
import Select from "../../../../input/Select";
import { Button } from "primereact/button";
import { Contacts } from "./Contacts";
import TextareaInput from "../../../../input/TextareaInput";
import { toast } from "react-toastify";
import { postCheckUser } from "../../../../../services/GeneralRegistration/postCheckUser";
import { Spouse } from "../Spouse";

export const CpfInputs = forwardRef(
  (
    {
      file,
      spouse,
      errors,
      setFile,
      control,
      contacts,
      setValue,
      getValues,
      setSpouse,
      telephones,
      setTelephones,
      onChangeSpouse,
      inputRequireds,
      setSpouseVisible,
      setEditPartner,
    },
    ref
  ) => {
    const [addSpouse, setAddSpouse] = useState(false);
    const maritalStatus = [
      {
        label: "Casado(a)-Comunhão Universal (Antes lei 6.515/77)",
        value: "Casado(a)-Comunhão Universal (Antes lei 6.515/77)",
      },
      {
        label: "Casado(a)-Comunhão Universal (Apos lei 6.515/77)",
        value: "Casado(a)-Comunhão Universal (Apos lei 6.515/77)",
      },
      {
        label: "Casado(a)-Comunhão Parcial",
        value: "Casado(a)-Comunhão Parcial",
      },
      {
        label: "Casado(a)-Separação Convencional de Bens",
        value: "Casado(a)-Separação Convencional de Bens",
      },
      { label: "Divorciado(a)", value: "Divorciado(a)" },
      {
        label: "Separado(a) Judicialmente",
        value: "Separado(a) Judicialmente",
      },
      { label: "Solteiro(a)", value: "Solteiro(a)" },
      { label: "União Estável", value: "União Estável" },
      { label: "Viúvo(a)", value: "Viúvo(a)" },
    ];

    useImperativeHandle(ref, () => ({
      submit: () => {
        // console.log("Submitting CPF Inputs:", getValues());
        return getValues();
      },
    }));

    const handleAddSpouse = (e) => {
      switch (e) {
        case "Casado(a)-Comunhão Universal (Antes lei 6.515/77)":
        case "Casado(a)-Comunhão Universal (Apos lei 6.515/77)":
        case "Casado(a)-Comunhão Parcial":
        case "Casado(a)-Separação Convencional de Bens":
          return handleEditMaritalStatus(true);
        case "Divorciado(a)":
        case "Separado(a) Judicialmente":
        case "Solteiro(a)":
        case "União Estável":
        case "Viúvo(a)":
          return handleEditMaritalStatus(false);
        default:
          return handleEditMaritalStatus(false);
      }
    };

    const handleEditMaritalStatus = (spouse) => {
      if (spouse) {
        setAddSpouse(true);
      } else {
        setValue(`spouse_id`, "");
        setAddSpouse(false);
      }
    };

    const handleAlterPartner = () => {
      setValue(`doc_conjuge`, spouse.doc);
      setValue(`name_conjuge`, spouse.name);
      setEditPartner({
        id: spouse.id,
        doc: spouse.doc,
        name: spouse.name,
      });
      setSpouseVisible(true);
    };

    const handlePhotoUpload = (data) => {
      // console.log(data, "DATAAAAA");
      // console.log(data.setFile, "FILEEEEE");
      setFile(data.setFile);
    };

    const handleCheckDoc = async (doc) => {
      // console.log(doc);
      const notification = toast.loading("Por favor aguarde a consulta...");
      const data = {
        doc: doc,
      };
      try {
        const response = await postCheckUser(data);
        // console.log(response);
        if (response.exists) {
          toast.update(notification, {
            render: "CPF já Cadastrado no Sistema!!",
            autoClose: 5000,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
        } else {
          toast.update(notification, {
            render: "CPF pode ser cadastrado no sistema",
            autoClose: 1000,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
        }
      } catch (error) {
        toast.update(notification, {
          render: "CPF inválido.",
          type: "error",
          theme: "colored",
          autoClose: 5000,
          isLoading: false,
        });
      }
    };

    useEffect(() => {
      if (getValues) {
        Object.keys(getValues).forEach((key) => {
          setValue(key, getValues[key]);
        });
      }
    }, [getValues, setValue]);

    useEffect(() => {
      if (contacts && Array.isArray(contacts)) {
        contacts.forEach((contact, index) => {
          setValue(`contacts[${index}]`, contact.number);
          setValue(`type_numbers[${index}]`, contact.type_number);
        });
      }
    }, [contacts, setValue]);

    useEffect(() => {
      if (telephones && Array.isArray(telephones)) {
        telephones.forEach((telephone, index) => {
          setValue(`contacts[${index}]`, telephone.number);
          setValue(`type_numbers[${index}]`, telephone.type_number);
        });
      }
    }, [telephones, setValue]);

    useEffect(() => {
      if (file) {
        setValue("profile_photo", file);
      }
    }, [file, setValue]);

    return (
      <>
        <div className="row">
          <div className="col-xl-2 my-auto col-profile-pic">
            <div className="mt-5 pt-3">
              <CardProfile
                name="profile_photo"
                control={control}
                setValue={setValue}
                preValue={file && file}
                onPhotoUpload={handlePhotoUpload}
              />
            </div>
          </div>
          <div className="col-xl-10 form-group my-auto">
            <Input
              name="type_doc"
              control={control}
              errors={errors}
              type="hidden"
              value="1"
            />
            <div className="row mt-3">
              <div className="col-xl-3 col-md-4 my-2">
                <MaskInput
                  name="doc"
                  control={control}
                  onComplete={() => handleCheckDoc(getValues(`doc`))}
                  label="CPF *"
                  mask="999.999.999-99"
                  isRequired={true}
                />
              </div>
              <div className="col-xl-3 col-md-4 my-2">
                <Input
                  name="name"
                  errors={errors}
                  control={control}
                  isRequired={true}
                  label="Nome Completo *"
                  validationRules={{
                    validate: (value) => {
                      const nameParts = value.trim().split(/\s+/);
                      if (nameParts.length < 2) {
                        return "Por favor, insira um nome completo.";
                      }
                      const lastName = nameParts[nameParts.length - 1];
                      if (lastName.length <= 2) {
                        return "O sobrenome deve ter mais que 2 caracteres.";
                      }
                      return true;
                    },
                  }}
                />
              </div>
              <div className="col-xl-3 col-md-4 my-2">
                <Input
                  name="rg"
                  control={control}
                  errors={errors}
                  isRequired={inputRequireds?.includes("rg")}
                  label={`RG ${inputRequireds?.includes("rg") ? "*" : ""}`}
                />
              </div>
              <div className="col-xl-3 col-md-4 my-2">
                <CalendarInput
                  name="date_of_birth"
                  control={control}
                  isRequired={inputRequireds?.includes("date_of_birth")}
                  errors={errors}
                  label={`Dt. de Nascimento ${
                    inputRequireds?.includes("date_of_birth") ? "*" : ""
                  }`}
                />
              </div>

              <div className="col-xl-3 col-md-4 my-2">
                <Input
                  name="nationality"
                  control={control}
                  errors={errors}
                  label={`Nacionalidade ${
                    inputRequireds?.includes("nationality") ? "*" : ""
                  }`}
                  isRequired={inputRequireds?.includes("nationality")}
                />
              </div>
              <div className="col-xl-3 col-md-4 my-2">
                <Input
                  name="profession"
                  control={control}
                  errors={errors}
                  isRequired={inputRequireds?.includes("profession")}
                  label={`Profissão ${
                    inputRequireds?.includes("profession") ? "*" : ""
                  }`}
                />
              </div>
              <div className="col-xl-3 col-md-4 my-2">
                <Input
                  name="issuing_authority"
                  control={control}
                  errors={errors}
                  label={`Órgão Emissor ${
                    inputRequireds?.includes("issuing_authority") ? "*" : ""
                  }`}
                  isRequired={inputRequireds?.includes("issuing_authority")}
                />
              </div>

              <div className="col-xl-3 col-md-4 my-2">
                <CalendarInput
                  name="date_issuing_authority"
                  control={control}
                  isRequired={inputRequireds?.includes(
                    "date_issuing_authority"
                  )}
                  errors={errors}
                  label={`Dt. de Emissão ${
                    inputRequireds?.includes("date_issuing_authority")
                      ? "*"
                      : ""
                  }`}
                />
              </div>
              <div className="col-xl-3 col-md-4">
                <Input
                  name="name_mother"
                  control={control}
                  errors={errors}
                  label={`Nome da Mãe ${
                    inputRequireds?.includes("name_mother") ? "*" : ""
                  }`}
                  isRequired={inputRequireds?.includes("name_mother")}
                />
              </div>
              <div className="col-xl-3 col-md-4">
                <Input
                  name="name_father"
                  control={control}
                  errors={errors}
                  label={`Nome do Pai ${
                    inputRequireds?.includes("name_father") ? "*" : ""
                  }`}
                  isRequired={inputRequireds?.includes("name_father")}
                />
              </div>

              <div className="col-xl-3 col-md-4">
                <NumberInput
                  name="family_income"
                  mode="currency"
                  label={`Renda Familiar ${
                    inputRequireds?.includes("family_income") ? "*" : ""
                  }`}
                  currency="BRL"
                  locale="pt-BR"
                  required={inputRequireds?.includes("family_income")}
                  useGrouping={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  control={control}
                  errors={errors}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-5">
            <div className="inline-flex align-items-center">
              <i className="pi pi-user me-2"></i>
              <b>Informações Avançadas</b>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Select
                name="marital_status"
                control={control}
                label={`Estado Civil ${
                  inputRequireds?.includes("marital_status") ? "*" : ""
                }`}
                options={maritalStatus}
                onChange={handleAddSpouse}
                required={inputRequireds?.includes("marital_status")}
              />
            </div>
            {addSpouse === true && !spouse?.id && (
              <div className="col-md-4 pt-3">
                <Button
                  label="Cônjuge"
                  icon="fa fa-plus"
                  tooltip="Adicione o conjuge"
                  className="mt-1 h6 w-100"
                  onClick={() => setSpouseVisible(true)}
                />
              </div>
            )}
            {addSpouse === true || (spouse && spouse?.id) && (
              <>
                <div className="col-md-3">
                  <Input
                    name="spouse"
                    control={control}
                    placehollader={spouse.name}
                    errors={errors}
                    label={spouse.name}
                    disabled={true}
                  />
                </div>
                <div className="col-md-1">
                  <Button
                    icon="fa fa-right-left"
                    tooltip="Alterar o cônjuge"
                    className="mt-4 h6 w-70"
                    type="button"
                    onClick={() => handleAlterPartner()}
                  />
                </div>
              </>
            )}
          </div>

          <Contacts
            control={control}
            errors={errors}
            contacts={contacts}
            setValue={setValue}
            getValues={getValues}
            telephones={telephones}
            inputRequireds={inputRequireds}
            setTelephones={setTelephones}
          />

          <div className="col-md-12 mt-5">
            <TextareaInput
              name="obs"
              max={255}
              control={control}
              errors={errors}
              isRequired={inputRequireds?.includes("obs")}
              label={`Observação ${inputRequireds?.includes("obs") ? "*" : ""}`}
            />
          </div>
        </div>
      </>
    );
  }
);
